import { Injectable } from '@angular/core';
import { ListLayout, ListLayoutMultipleComponent } from 'gung-list';
import { CartConfigService, CartService, CartRow, BaseViewConfigService,ProductAssortmentParentService } from 'gung-standard';
import { CultCartListComponent } from '../components/checkout/cult-cart-list/cult-cart-list.component';

@Injectable({
  providedIn: 'root'
})
export class CultCartConfigService extends CartConfigService {
  constructor(protected cartService: CartService, baseViewConfigService: BaseViewConfigService, productAssortmentParentService: ProductAssortmentParentService) {
    super(cartService, baseViewConfigService, productAssortmentParentService);
  }

  getLayouts(): ListLayout<CartRow>[] {
    return [
      {
        getIconClass: () => '',
        getName: () => 'Cart grid',
        getListItemComponent: () => CultCartListComponent,
        getListLayoutComponent: () => ListLayoutMultipleComponent
      }
    ];
  }
}
